var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.isLoggedIn)?[_c('app-navigation-drawer',{ref:"appNavigationDrawer"}),_c('app-navigation-bar',{on:{"drawer:toogle":function($event){return _vm.$refs.appNavigationDrawer.toogleDrawer()}}})]:_vm._e(),_c('router-view'),_c('app-notification-alert')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }